import React from 'react';
import { Building, ArrowRight } from 'lucide-react';

/**
 * Prompt shown in the compose dialog when the account has no company name or
 * postal address on file.
 *
 * The send path refuses a message without them. They are NOT printed under
 * the email — the account holds them so the business behind a campaign is
 * known — so this copy must not promise that they appear anywhere.
 *
 * Sign-up asks for neither: a requirement put to somebody who has not signed
 * up yet is an obstacle, not guidance. This is where the user meets it, at the
 * moment it matters, with a link to the field that needs filling.
 *
 * One line and a link, deliberately (2026-08-05) — anything longer is read as
 * an excuse. Whether sending is actually refused is shown by the Send button,
 * which EmailPopup disables from the same `blocking` flag, so it is not said
 * twice here.
 *
 * Renders nothing once the details are there.
 */
const SenderIdentityNotice = ({ missing = [], onGoToProfile = () => {} }) => {
  if (!missing || missing.length === 0) return null;

  const labels = missing.map((item) => item.label || item);
  const what = labels.length === 2 ? `${labels[0]} and ${labels[1]}` : labels[0];

  return (
    <div className="p-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-xl">
      <div className="flex items-start gap-3">
        <Building className="w-5 h-5 text-amber-500 dark:text-amber-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-amber-800 dark:text-amber-300">
            Add your {what} in order to send email
          </p>
          <button
            onClick={onGoToProfile}
            className="mt-3 inline-flex items-center gap-2 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            Go to Profile
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SenderIdentityNotice;
